module.exports = __webpack_public_path__ + "static/media/zip.bb7faaef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zip.svg
// module id = 7
// module chunks = 0